import { memo, useActionState, useEffect } from "react";
import { access, isString, logTimestamp, split, useProperty } from "../../support/general";
import { sendCommand } from "../../support/LocalCommand";
import { makeUniversalBlockKey, modelStore } from "../storage/model";
import $ from "jquery"
import { makeStore } from "../../support/pile";
import { blockDmlToDhtml, dmlToDhtml, ensureBlockDmlCache } from "../storage/dml";


export const Block  = memo (function ({scriptId,blockId}){

    var blockUid = makeUniversalBlockKey(scriptId,blockId);

    modelStore.useSelector(data=>{
        //logTimestamp("block selector")
        //console.log ("run Block_Selector");
        var r = "none_0_empty"
        var block = data.model.Block[blockUid];
        if (block){
            //ensureBlockDmlCache(block);
            var indent = block.meta.indent;
            indent = indent?indent:0;
            r = block.type+"_"+indent+"_"+block.text;
        }
        return block;//r
    },blockUid);

    // var indent = modelStore.useSelector(state=>{
    //     var blockUid = makeUniversalBlockKey(scriptId,blockId);
    //     return access(state.model,["Block",blockUid,"meta","indent"]);
    // },blockUid)
    // indent = indent?indent:0;
    //var underscoreIndex = info.indexOf("_");

    var blockUid = makeUniversalBlockKey(scriptId,blockId);
    var block = modelStore.access(["model","Block",blockUid]);

    var type = block?block.type:'none';
    //var text = block?blockDmlToDhtml(scriptId,block):"";
    var text = block?block.text:"";
    var indent = block?block.meta.indent:0;
    indent = indent ? indent : 0;

    // text = blockDmlToDhtml(scriptId); 

    text = text?text:<br/>;

    function onFocus(){
        console.log ("Focussed on block : "+ blockId)
    }

    var innerStyle = {
        whiteSpace : 'pre-wrap',
    } 
    if (indent){
        // innerStyle.marginLeft = 4*indent+"em"
    }

    function onInput(e){
        var ii=0
    }
    // logTimestamp("run Block : "+blockId);// + " : " + text
    return (<div
        id = {blockUid}
        className = {"block block_"+type}
        style={{
            width : '100%',
            paddingLeft : 4*indent+"em",
        }}
        onFocus = {onFocus}
        onDrop = {(e)=>{
            if(e.stopPropagation) e.stopPropagation();
            if(e.preventDefault) e.preventDefault();
            e.cancelBubble=true;
            e.returnValue=false;
            return false;
        }}
    >
        <div
           
            className = {"inner_"+type+ " " +blockUid+"_inner"}
            style={innerStyle}
            
        >{text}</div>
    </div>);
});